export default __webpack_public_path__ + "static/media/H_wdt_c_cap_1.b5dd4ba1.mp3";